<script lang="ts">
    import { onMount, createEventDispatcher } from "svelte";
    import { serpPageConfigStores } from "../../../stores/stores.serpPage";
    import { FilterStores, ParametersFilterResponse } from "../../../../types/types.serpPage";
    import { Icon } from "../../../../generic/components";

    export let filter: FilterStores;

    let show: boolean = false;
    let isClosed: boolean = false;
    let isEmpty: boolean = false;
    let showMoreBtnVisible: boolean = false;
    let limit: number = $serpPageConfigStores.limitFilter ?? 0;
    const dispatch = createEventDispatcher();

    onMount(() => {
        isClosed = $serpPageConfigStores.isFilterCloseOnStart ?? false;
        isEmpty = filter.currentValueSelected?.length == 0;
        show = !isClosed && !isEmpty;
        limit = $serpPageConfigStores.limitFilter ?? 0;
        showMoreBtnVisible = filter.currentValues.length > limit;
    });

    function toogleCollapse() {
        show = !show;
    }

    function checkIsChecked(currentValue: ParametersFilterResponse): boolean {
        return filter.currentValueSelected?.length > 0 && filter.currentValueSelected.includes(currentValue.name);
    }

    function valueChanged(newValue: string) {
        dispatch("valueChanged", {
            value: newValue,
            filter: filter,
        });
    }
</script>



<div class="dropdown">
    <button class:collapsed={!show} on:click={toogleCollapse} type="button" data-bs-toggle="dropdown" aria-expanded="false" title="">
        {#if filter.currentValueSelected?.length> 0} <span class="badge rounded-pill text-bg-primary">{filter.currentValueSelected?.length}</span> {/if} {filter.name}
        <Icon template="ic-arrow-down" styleClass="bsCollapseIcon" />
    </button>
    <ul class="dropdown-menu mt-1 border rounded">
        {#each filter.currentValues as currentValue}
            <li class:text-bg-primary={checkIsChecked(currentValue)}>
                <button type="button" on:click={() => {valueChanged(currentValue?.name)}} title="">
                    {filter.getNameOfValue(currentValue.name)}
                </button>
            </li>
        {/each}
    </ul>
</div>
